import { Middleware } from "redux";
import IStore from "../models/IStore";
import IAction from "../models/IAction";
import IError from "../models/IError";
import ToastStatusEnum from "../constants/ToastStatusEnum";
import * as ToastsAction from "../stores/toasts/ToastsAction";
import { removeCookieData } from "utilities/CookieUtility";
import CookieEnum from "constants/CookieEnum";
import { isIAction, toUnknownAction } from "../utilities/ReduxUtility";

const errorToastMiddleware =
  (): Middleware<object, IStore> =>
  (_store) =>
  (next) =>
  (action): unknown => {
    if (isIAction(action) && action.error) {
      const errorAction = action as Required<IAction<IError>>;

      if (errorAction.payload.message === "Invalid token." || errorAction.payload.message === "Geçersiz simge.") {
        removeCookieData(CookieEnum.User);
        removeCookieData(CookieEnum.Token);
      }
      return next(toUnknownAction(ToastsAction.add(errorAction.payload.message, ToastStatusEnum.Error)));
    }

    return next(action);
  };

export default errorToastMiddleware;
